import { render, staticRenderFns } from "./AddTenancyView.vue?vue&type=template&id=25048400&scoped=true"
import script from "./AddTenancyView.vue?vue&type=script&lang=js"
export * from "./AddTenancyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25048400",
  null
  
)

export default component.exports